export default async function asyncFailToDefault<T>(
  promise: Promise<T>,
  defaultValue: T
): Promise<T> {
  try {
    const result = await promise;
    return result;
  } catch {
    return Promise.resolve(defaultValue);
  }
}
